export enum TStates {
  Success = "success",
  Warning = "warning",
  Danger = "danger",
  None = "none",
}
